import "./ModalWindow.scss";

type ModalWinType = {
    title: string,
    message: string,
    classNameModal: string,
    handleCloseModal: () => void
}

export const ModalWindow = ({ title, message, classNameModal, handleCloseModal }: ModalWinType) => {
    return (
        <section className={`modal-win ${classNameModal}`} role="dialog" aria-modal="true" aria-labelledby="modal-window-title">
            <div className="modal-win__container">
                <button className="modal-win__close" onClick={handleCloseModal} aria-label="Закрыть окно">
                    ×
                </button>
                <div className="modal-win__content">
                    <h2 id="modal-window-title" className="modal-win__title">{title}</h2>
                    <p className="modal-win__message">{message}</p>
                </div>
            </div>
        </section>
    );
};
